import * as tslib_1 from "tslib";
import { GetRecurrenceQueryResponse, ListRecurrenceQueryResponse, Occurrence, PagedResult, Recurrence, RecurrencePageResult, } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import { RecurrenceQueries } from './recurrence.queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./recurrence.queries";
var RecurrenceService = /** @class */ (function () {
    function RecurrenceService(apollo, queries) {
        this.apollo = apollo;
        this.queries = queries;
    }
    RecurrenceService.prototype.listRecurrences = function (_a) {
        var where = _a.where, options = _a.options;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                return [2 /*return*/, this.apollo.query({
                        query: this.queries.listRecurrences(),
                        variables: {
                            limit: options.limit,
                            offset: options.offset,
                            orderBy: options.orderBy,
                            where: where
                        }
                    }).toPromise()
                        .then(function (response) {
                        return {
                            items: response.data.recurrences.items,
                            totalCount: response.data.recurrences.totalCount,
                            filtered: Boolean(where.archived !== false ||
                                where.locationId_in ||
                                where.segmentId_in ||
                                where.interval_in ||
                                where.maintenanceTypeId_in ||
                                where.companyId_in)
                        };
                    })];
            });
        });
    };
    RecurrenceService.prototype.getById = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, variables;
            return tslib_1.__generator(this, function (_a) {
                query = this.queries.getRecurrenceById();
                variables = { id: id };
                return [2 /*return*/, this.apollo.query({
                        query: query,
                        variables: variables
                    }).toPromise()
                        .then(function (response) { return response.data.recurrence; })];
            });
        });
    };
    RecurrenceService.prototype.save = function (id, recurrence) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (id) {
                    return [2 /*return*/, this.update(id, recurrence)];
                }
                return [2 /*return*/, this.create(recurrence)];
            });
        });
    };
    RecurrenceService.prototype.create = function (recurrence) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.mutate({
                        mutation: this.queries.createRecurrence(),
                        variables: {
                            input: recurrence
                        }
                    }).toPromise()
                        .then(function (result) { return result.data['createRecurrence']; })];
            });
        });
    };
    RecurrenceService.prototype.update = function (id, recurrence) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .mutate({
                        mutation: this.queries.updateRecurrence(),
                        variables: {
                            id: id,
                            input: recurrence
                        }
                    })
                        .toPromise()
                        .then(function (result) { return result.data['updateRecurrence']; })];
            });
        });
    };
    RecurrenceService.prototype.listOccurrences = function (_a) {
        var where = _a.where, options = _a.options;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: this.queries.listOccurrences(),
                        variables: {
                            limit: options.limit,
                            offset: options.offset,
                            orderBy: options.orderBy,
                            where: where
                        }
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return data['occurrences'];
                    })];
            });
        });
    };
    RecurrenceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RecurrenceService_Factory() { return new RecurrenceService(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.RecurrenceQueries)); }, token: RecurrenceService, providedIn: "root" });
    return RecurrenceService;
}());
export { RecurrenceService };
